enum Actions {
  SET_FILTERS = 'setFilters',
  TOGGLE_SHOW_OPEN_SHIFTS = 'toggleShowOpenShifts',
  SET_SHOW_ONLY_MINE_SHIFTS = 'setShowOnlyMineShifts',
  SET_LOCATIONS_POSITION_IDS = 'setLocationsPositionIds',
  SET_SHIFT_ROTATION_GROUP_IDS = 'setShiftRotationGroupIds',
}

export default Actions;
